import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './components/App/App';
import {
  createEssentials,
  RootEssentialsProvider,
} from '@wix/fe-essentials-standalone';
import { FedopsProvider } from '@wix/fe-essentials-standalone/react';
import { create as createFedopsLogger } from '@wix/fedops-logger';
import { AppContext } from './components/App/AppContext';
import BiLoggerFactory from '@wix/fe-essentials-standalone/bi';
import { devibePageStartLoadingSrc196Evid2 } from '@wix/bi-logger-dev-tools-data/v2';
import {
  getReferralInfoFromCurrentUrl,
  getReferrerFromCurrentUrl,
} from '@wix/dev-center-pages-common/deVibe';

const biLogger = BiLoggerFactory.factory().logger();
const fedopsLogger = createFedopsLogger('devibe-onboarding-page');
function decodeHtmlEntities(encodedString: string) {
  const tempElement = document.createElement('div');
  tempElement.innerHTML = encodedString;
  return tempElement.textContent;
}

const reportPageLoadStart = () => {
  biLogger.report(
    devibePageStartLoadingSrc196Evid2({
      Page_name: 'Onboarding',
      Product_Area: 'Onboarding',
      URL: window.location.href,
      Referal_url: getReferrerFromCurrentUrl(),
      Window_height: window.innerHeight,
      Window_width: window.innerWidth,
      Screen_height: screen.height,
      Screen_width: screen.width,
      Referal_info: getReferralInfoFromCurrentUrl(),
    }),
  );
};
const standaloneEssentials = createEssentials({
  fedops: {
    appName: 'devibe-onboarding-page',
  },
  experiments: { scopes: ['devibe-onboarding-page'] },
  i18n: {
    messages: JSON.parse(decodeHtmlEntities(window.__MESSAGES__) || '{}'),
  },
  environment: {
    language: window.__LOCALE__,
    artifactId: '',
    version: '',
  },
  errorHandler: {
    biDefaultsOverrides: {
      app_id: 'devibe-onboarding-page',
      hostingEnvironment: 'devibe-onboarding-page',
    },
  },
});

reportPageLoadStart();
const domNode = document.getElementById('root')!;
const root = createRoot(domNode);

const appContext = {
  userId: window.__USER_ID__ || '',
};

root.render(
  <RootEssentialsProvider essentials={standaloneEssentials}>
    <FedopsProvider value={fedopsLogger}>
      <AppContext.Provider value={appContext}>
        <App />
      </AppContext.Provider>
    </FedopsProvider>
  </RootEssentialsProvider>,
);
